module.exports = __webpack_public_path__ + "img/LinksWhite.56bfa504.svg";